import type { RohsBriefingStep } from '../../utils/rohsLegislationBriefing'
import { V2RohsLegislationBriefingStepShell } from './V2RohsLegislationBriefingStepShell'

export function V2RohsApplicabilityStep({
  step,
  index,
}: {
  step: RohsBriefingStep
  index: number
}) {
  return <V2RohsLegislationBriefingStepShell step={step} index={index} />
}
